import React, { Component } from "react";
import Popup from "../../../common/Popup";
import {
    DKCalendar, DKLabel, DKInput, DKButton, DKLine, DKSpinner, TOAST_TYPE,
    showToast, DKIcon, removeLoader, showLoader, DKTooltipWrapper,
    DKIcons,DKCheckMark
} from "deskera-ui-library";
import Utility, { deepClone } from "../../../../utility/Utility";
import moment from "moment";
import { DATE_FORMAT, INPUT_TYPE } from "../../../../constants/Constant";
import MaskInput from "../../../../SharedComponents/MaskInput/MaskInput";
import date_range from "../../../../assets/icons/date_range.svg";
import ic_info_message from "../../../../assets/icons/ic_info_gray01.png";
import { EDIT_IR8S_FORM, SECTION_A_FORM } from "./SGReportsConstant";
import ReportService from "../../../../services/ReportService";
import { TABLES, TABLE_DISPLAY_NAME } from "../../../../managers/TableManger";
import DataGridHolderPayroll from "../../../common/DataGridHolderPayroll";
import { parseColumnConfig, parseVisibleColumnConfig } from "../../../configs/config";
import { convertDateToJson, scrollToError } from "../../../../managers/common/CommonUtil";

export default class EditIR8SForm extends Component {
    interval;
    defaultValues = {
        contributionAtFullRate:false
    }
    editIR8SForm = deepClone(EDIT_IR8S_FORM)
    selectYear = {
        toggle: false,
        startDate: moment(moment().format()).startOf('month'),
        endDate: moment(moment().format()).endOf('month'),
        defaultDate: false,
        hasError: false,
        errorMsg: 'End date should not be less than Start date'
    }
    defaultAmount = "0.00"
    gridContainer = React.createRef();
    originalIR8SData
    grid = {
        gridActions: {
            filters: [],
            currentPage: 1,
            totalPageCount: 1
        },
        gridData: {
            columnData:parseVisibleColumnConfig(parseColumnConfig(SECTION_A_FORM)),
            rowData: [],
            filter: [],
            originalData: []
        },
        canValidate: false
    }
    constructor(props) {
        super(props)
        this.state = {
            gridWidth:950
        }
        if (this.props.data) {
            this.defaultValues = this.props.data;
            this.getIR8SForm()
        }
    }
    componentDidMount() {
        
        this.setState({
            gridWidth: (this.gridContainer?.current?.clientWidth || 950)
        })
    }
    updateState() {
        this.setState({
            ...this.state
        })
    }
    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval)
        }
    }
    getIR8SForm() {
        let param = {
            year: this.defaultValues.year,
            cpfAccountNo: this.defaultValues.cpfAccount,
            formType: 'IR8S'
        }
        showLoader()
        ReportService.getIR8SForm(param, this.defaultValues['employee'].id).then(res => {
            removeLoader()
            this.originalIR8SData=res
            let sec = res.sectionC[0]
            delete sec['sectionC']
            sec = {
                ...sec,
                amount: this.getFormattedAmount(sec.amount),
                emrContribution: this.getFormattedAmount(sec.emrContribution),
                emrInterest: this.getFormattedAmount(sec.emrInterest), 
                empContribution: this.getFormattedAmount(sec.empContribution),
                empInterest: this.getFormattedAmount(sec.empInterest),
            }
            this.defaultValues = {
                ...this.defaultValues,
                ...res,
                ...res.authorizePerson,
                ...res.authorizePerson.company,
                ...res.employee,
                ...sec,
                employeescontribution: this.getFormattedAmount(res.employeescontribution),
                employerscontribution: this.getFormattedAmount(res.employerscontribution),
                designation: res.authorizePerson.designation
            }
            
            this.grid.gridData.rowData = this.defaultValues.tableData.map(tableRow=>{
                return {
                    ...tableRow,
                    addemployee: this.getFormattedAmount(tableRow.addemployee),
                    addemployer:this.getFormattedAmount(tableRow.addemployer),
                    addwages: this.getFormattedAmount(tableRow.addwages),
                    ordemployee: this.getFormattedAmount(tableRow.ordemployee),
                    ordemployer: this.getFormattedAmount(tableRow.ordemployer),
                    ordwages: this.getFormattedAmount(tableRow.ordwages)
                }
            })
            if (this.defaultValues['periodFrom']) {
                
                this.selectYear.startDate = moment(this.defaultValues.periodFrom, DATE_FORMAT.YYYYMMDD).format();
                this.selectYear.endDate = moment(this.defaultValues.periodTo, DATE_FORMAT.YYYYMMDD).format()
            }
            this.updateState()
        }, error => {

        })
    }
    getFormattedAmount(amount) {
        return !Utility.isEmpty(amount)  ? amount : this.defaultAmount
    }
    save() { 
        
        this.canValidate = true;
        this.updateState()
        this.interval = setTimeout(() => {
            if (this.validateForm()) {
                return;
            }
            let param = this.prepareJSONForSubmit()
            showLoader()
            ReportService.saveIR8S(param).then(res => {
                removeLoader()
                if (param && param.id) {
                    showToast("Form updated successfully", TOAST_TYPE.SUCCESS);
                } else {
                    showToast("Form saved successfully", TOAST_TYPE.SUCCESS);
                }

                this.props.onClose()
            }, error => {
                removeLoader()
                showToast("Somthing went wrong", TOAST_TYPE.FAILURE);
            })
        }, 100)
    }
    getFormattedDate(date,inputFormat) {
        return convertDateToJson(date)
    }
    prepareJSONForSubmit() {
        let param = {
            ...this.defaultValues
        }
        param.employee.joiningDate = param.joiningDate;
        let sectionCData = this.defaultValues.sectionC[0]
        sectionCData = {
            datePaid: this.getFormattedDate(this.defaultValues.datePaid,DATE_FORMAT.YYYYMMDD),
            emrDate: this.getFormattedDate(this.defaultValues.emrDate,DATE_FORMAT.YYYYMMDD),
            empDate: this.getFormattedDate(this.defaultValues.empDate,DATE_FORMAT.YYYYMMDD),
            signedDate: this.getFormattedDate(this.defaultValues.signedDate,DATE_FORMAT.YYYYMMDD),
            periodFrom: this.getFormattedDate(this.defaultValues.periodFrom,DATE_FORMAT.YYYYMMDD),
            periodTo: this.getFormattedDate(this.defaultValues.periodTo,DATE_FORMAT.YYYYMMDD),
            amount: this.defaultValues.amount,
            emrContribution: this.defaultValues.emrContribution,
            emrInterest: this.defaultValues.emrInterest,
            empContribution: this.defaultValues.empContribution,
            empInterest: this.defaultValues.empInterest
        }
        param['sectionC'][0] = sectionCData
        param['signedDate'] = this.getFormattedDate(this.defaultValues.signedDate,DATE_FORMAT.YYYYMMDD)
        let employee = {
            ...this.originalIR8SData.employee,
            dob: this.getFormattedDate(this.defaultValues.dob,DATE_FORMAT.YYYYMMDD),
            nricNo: this.defaultValues['nricNo'],
            joiningDate:  this.getFormattedDate(this.defaultValues.joiningDate,DATE_FORMAT.YYYYMMDD) 
            
        }
        param['employee'] = employee
        param['dateOfSpore'] =  this.getFormattedDate(this.defaultValues.dateOfSpore,DATE_FORMAT.YYYYMMDD)
        param['tableData'] = this.defaultValues['tableData'].map(month=>{delete month['selected']; return month})
        param['year'] = this.props.data.year
        let authorizePerson = {
            ...this.originalIR8SData.authorizePerson,
            designation: this.defaultValues.designation,
            company: {
                ...this.originalIR8SData.authorizePerson.company,
                companyName: this.defaultValues.companyName
            }
        }
        param['authorizePerson'] = authorizePerson;
        delete param['address']
        delete param['amount']
        return param
    }
    validateForm() {
        let isInvalid = false;
        this.editIR8SForm.sectionC.ordinaryWages.forEach(field => {
            if (!field.isValid) {
                isInvalid = true;
                scrollToError(field.key)
            }
        })
        this.editIR8SForm.sectionC.amountOfRefundEmployer.forEach(field => {
            if (!field.isValid) {
                isInvalid = true;
                scrollToError(field.key)
            }
        })
        this.editIR8SForm.sectionC.amountOfRefundEmployee.forEach(field => {
            if (!field.isValid) {
                isInvalid = true;
                scrollToError(field.key)
            }
        })
        this.editIR8SForm.remark.forEach(field => {
            if (!field.isValid) {
                isInvalid = true;
                scrollToError(field.key)
            }
        })
        this.editIR8SForm.sectionB.forEach(field => {
            if (!field.isValid) {
                isInvalid = true;
                scrollToError(field.key)
            }
        })
        this.editIR8SForm.authorizePerson.forEach(field => {
            if (!field.isValid) {
                isInvalid = true;
                scrollToError(field.key)
            }
        })
        return isInvalid;
    }
    onChange(value, index, obj) {

        this.defaultValues[obj.key] = (value && value.id) ? value.id : value;
        this.updateState()
    }
    validator(value, index, obj) {
        if (obj.validation && obj.validation.regExp) {
            const regex = new RegExp(obj.validation.regExp);
            obj.isValid = regex.test(value);
            return regex.test(value);
        } else if (obj.required && typeof value === "string" && Utility.isEmpty(value.trim())) {
            obj.isValid = false
            return false;
        } else if (obj.required && Utility.isEmpty(value) && (typeof value === "number" && value !== 0)) {
            obj.isValid = false
            return false;
        } else if (obj.required && typeof value === "object" && (Utility.isEmpty(value) || Utility.isEmpty(this.defaultValues[obj.key])) ) {
            obj.isValid = false
            return false;
        } else if ((obj.validation) && (obj.validation.maxLength) && (obj.validation.maxLength < value.length)) {
            obj.isValid = false
            return false;
        } else if ((obj.validation) && (obj.validation.minLength) && (obj.validation.minLength > value.length)) {
            obj.isValid = false
            return false;
        } else if ((obj.validation) && (obj.validation.minValue) && (value < obj.validation.minValue)) {
            obj.isValid = false
            return false;
        } else {
            obj.isValid = true;
            return true;
        }
    }
    renderCalendarForDateSelect(value, index, obj) {
        return (
            <div className="ml-l">
                {this.selectYear.toggle && (
                    <DKCalendar
                        className="position-absolute border-m shadow-m bg-white z-index-6 "
                        isDateRange={true}
                        startDate={this.selectYear.startDate ? new Date(this.selectYear.startDate) : new Date()}
                        endDate={this.selectYear.endDate ? new Date(this.selectYear.endDate) : new Date()}
                        onClose={() => {
                            if (moment(this.selectYear.startDate).diff(this.selectYear.endDate) <= 0 || this.selectYear.endDate == null) {
                                this.selectYear = {
                                    toggle: false,
                                    startDate: this.selectYear.startDate,
                                    endDate: this.selectYear.endDate,
                                    defaultDate: false,
                                    hasError: false
                                };
                            } else {
                                this.selectYear = {
                                    toggle: false,
                                    startDate: this.selectYear.startDate,
                                    endDate: this.selectYear.endDate,
                                    defaultDate: false,
                                    hasError: true,
                                    errorMsg: "End date should not be less than Start date"
                                };
                            }

                            this.updateState()
                        }}
                        onSelectDate={(start, end) => {
                            if (start && end) {
                                let startDate = start;
                                let endDate = end;
                                if (moment(startDate).diff(endDate) <= 0 || endDate == null) {
                                    this.selectYear = {
                                        toggle: false,
                                        startDate: startDate,
                                        endDate: endDate,
                                        defaultDate: false,
                                        hasError: false
                                    };
                                    // this.defaultValues[obj.key] = `${} - ${}`
                                    this.defaultValues['periodFrom'] = moment(new Date(this.selectYear.startDate)).format(DATE_FORMAT.YYYYMMDD)
                                    this.defaultValues['periodTo'] = moment(new Date(this.selectYear.endDate)).format(DATE_FORMAT.YYYYMMDD)
                                    // const numberOfDays = this.calculateNumberofDays(this.defaultValues[obj.key]);
                                    // this.defaultValues['days'] = numberOfDays;
                                } else {
                                    this.selectYear = {
                                        toggle: false,
                                        startDate: startDate,
                                        endDate: endDate,
                                        defaultDate: false,
                                        hasError: true,
                                        errorMsg: "End date should not be less than Start date"
                                    };
                                }
                                this.updateState()
                            }
                        }}

                    />
                )}
            </div>
        )
    }
    getFieldValue(obj) {
        switch (obj.key) {
            case 'employeeName':
                return this.defaultValues['employee']?.fullName;
            case 'period':
                return this.getOccupationPeriod(this.defaultValues)
            default:
                if (obj.options && obj.options.length != 0) {
                    if (obj.options[0].id) {
                        return obj.options.find(o => o.id == this.defaultValues[obj.key])
                    } else {
                        return obj.options.find(o => o == this.defaultValues[obj.key])
                    }
                }
                return obj.type==='date' ? (!Utility.isEmpty(this.defaultValues[obj.key]) ? new Date(this.defaultValues[obj.key]) :""): this.defaultValues[obj.key];
        }

    }
    getOccupationPeriod(data) {
        if (data && !Utility.isEmpty(data['periodFrom'])) {
            
            const from = Utility.formatDate(data['periodFrom'], DATE_FORMAT.YYYYMMDD);
            const to = Utility.formatDate(data['periodTo'], DATE_FORMAT.YYYYMMDD);
            
            return from + ' - ' + to;
        } else {
            return ''
        }

    }
    getErrorMessage(obj) {
        let errorMessage;
        if (Utility.isEmpty(this.getFieldValue(obj)) && obj.required) {
            errorMessage = `Please enter a valid ${obj.name}`;
        } else {
            errorMessage = obj.errorMessage
        }
        return errorMessage
    }
    onRowUpdate(data) {
        console.log(data)
        if(Utility.isEmpty(data.rowData[data.columnKey])){
            data.rowData[data.columnKey] = '0'
        }
        this.defaultValues['tableData'][data.rowIndex] = data.rowData
    }
    getSectionA() {
        return(
            <>
                {/* <DKLabel className="fw-m fs-m" text="Section A"/> */}
                <div className="column parent-width flex-1 " style={{minHeight:'40vh'}}>
                <div className="column parent-width mb-s position-relative flex-1 " ref={this.gridContainer}>
                    <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_GIRO}
                        displayTableName={"Section A"}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        allowColumnAdd={false}
                        allowRowAdd={false}
                        allowColumnSort={false}
                        refresh={false}
                        allowDataExport={false}
                        allowRowEdit={true}
                        showContextEdit={false}
                        isActionEnabled={true}
                        contextMenu={true}
                        isMenuVisible={true}
                        showContextMenu={true}
                        gridData={this.grid.gridData}
                        filter={this.grid.gridActions.filters}
                        currentPage={this.grid.gridActions.currentPage}
                        totalPageCount={this.grid.gridActions.totalPageCount}
                        addButtonConfig={[
                            
                        ]}
                        onRowOpenBtnHidden={true}
                        onFilter={(dataList, queries) => {

                        }}
                        onRowUpdate={(data) => {
                            this.onRowUpdate(data);
                        }}
                        onRowDelete={(data) => {
                            // this.onRowDelete(data)
                        }}
                        onPaginationClick={(requestedPageNumber) => {

                        }}
                        onSelection={(selection) => {
                            // this.selection = (selection);
                        }}
                        isActionEnabled={false}

                        allowBulkOperation={false}
                        // dateFormat={this.dateFormat}

                        onCancelContext={() => {
                            // this.onContextCancel();
                        }}
                        contextMenu={false}
                        onRowClick={(data) => {
                            // this.onRowClick(data)
                        }}
                        onPaginationClick={(requestedPageNumber) => {
                            // this.grid.gridActions.currentPage = requestedPageNumber
                            // this.getAttendanceData()
                        }}
                        // onSearch={(data) => this.onSearch(data)}
                        // makePayment={this.makePayment}
                        isMenuVisible={false}
                        gridWidth={this.state.gridWidth}
                    />
                </div>
            </div>
            </>
        )
    }
    getContributionFullRate() {
        return (
            <div
                className=" d-flex pt-s align-items-center parent-height cursor-hand mb-l"
                onClick={() => {
                    this.defaultValues.contributionAtFullRate = !this.defaultValues.contributionAtFullRate;
                    this.updateState()
                }}
            >
                <DKCheckMark isSelected={this.defaultValues.contributionAtFullRate} color="bg-app" />
                <DKLabel className="ml-m" text="Has approval been given by CPF Board to make full contributions (for SPR status granted on/after 1 Jan 2018)" />

            </div>
        )
    }
    getSectionB() {
        return (
            <>
                <DKLabel className="fw-m fs-m" text="Section B" />
                <div className="row row-responsive flex-wrap border-m border-radius-s card-shadow m-v-l  pt-s ">
                    {this.editIR8SForm.sectionB.map((field, index) => {

                        return (field.uiVisible) ? <div className="web-width-50 pb-xs">{this.renderField(field, index)}</div> : null
                    })}
                </div>
            </>
        )
    }
    getSectionC() {
        return (
            <>
                <DKLabel className="fw-m fs-m" text="Section C" />
                <div className="border-m border-radius-s card-shadow m-v-l  pt-s ">
                    <DKLabel className="fw-m p-h-m pb-s" text="Ordinary/Additional Wages" />
                    <div className="row row-responsive flex-wrap ">

                        {this.editIR8SForm.sectionC.ordinaryWages.map((field, index) => {

                            return (field.uiVisible) ? <div className="web-width-50 ">{this.renderField(field, index)}</div> : null
                        })}
                    </div>
                </div>


                <div className="border-m border-radius-s card-shadow m-v-l  pt-s ">
                    <DKLabel className="fw-m p-h-m pb-s" text="Amount of refund Employer" />
                    <div className="row row-responsive flex-wrap ">

                        {this.editIR8SForm.sectionC.amountOfRefundEmployer.map((field, index) => {

                            return (field.uiVisible) ? <div className="web-width-50 ">{this.renderField(field, index)}</div> : null
                        })}
                    </div>
                </div>


                <div className="border-m border-radius-s card-shadow m-v-l  pt-s ">
                    <DKLabel className="fw-m p-h-m pb-s" text="Amount of refund Employee" />
                    <div className="row row-responsive flex-wrap ">

                        {this.editIR8SForm.sectionC.amountOfRefundEmployee.map((field, index) => {

                            return (field.uiVisible) ? <div className="web-width-50 ">{this.renderField(field, index)}</div> : null
                        })}
                    </div>
                </div>


            </>
        )
    }
    getSectionRemark() {
        return (
            <>
            <DKLabel className="fw-m fs-m" text="Remark" />
                <div className="border-m border-radius-s card-shadow m-v-l  p-v-s ">
                    <div className="row row-responsive flex-wrap ">
                        {this.editIR8SForm.remark.map((field, index) => {
                            return (field.uiVisible) ? <div className="web-width-50 ">{this.renderField(field, index)}</div> : null
                        })}
                    </div>
                </div>
            </>
        )
    }
    renderField(obj, index) {
        return (
            <>
                {!obj.showMask && <>
                    <div className="row ">
                        <DKInput
                            key={obj.key}
                            className={`p-v-s p-h-r parent-height ${obj.type !== "date-range" ? "mb-s" : ""} ${obj.key}`}
                            icon={obj.icon}
                            title={obj.name}
                            placeholder={obj.name}
                            value={this.getFieldValue(obj)}
                            options={obj.options}
                            type={obj.type}
                            errorMessage={this.getErrorMessage(obj)}
                            labelClassName=" text-align-left "
                            canValidate={this.canValidate || obj.canValidate}
                            onChange={(value) => {
                                obj.canValidate = true
                                this.onChange(value, index, obj);
                            }}
                            validator={(value) => {
                                return this.validator(value, index, obj)
                            }}
                            tooltip={{
                                content: obj.tooltipText,
                                className: "warning-tooltip-prop",
                            }}
                            formatter={(obj) => {
                                /** How to render a selected option in case of object **/
                                return obj.name;
                            }}
                            dropdownConfig={{
                                className: "",
                                style: {},
                                allowSearch: obj.options && obj.options.length > 6 ? true : false,
                                searchableKey: "name",
                                data: obj.options,
                                renderer: (index, obj) => {
                                    /** How to render value in Dropdown in case of object **/
                                    return <DKLabel text={`${obj.name}`} />;
                                },
                                onSelect: (index, obj) => {

                                },
                            }}
                            direction={obj.direction}
                            required={obj.required}
                            readOnly={obj.readOnly}
                        />
                        {obj.type == "date-range" && <DKIcon className=" z-index-1 cursor-hand mt-l" style={{ marginLeft: -46, opacity: .5 }} src={date_range} onClick={() => {
                            this.selectYear = {
                                toggle: (this.selectYear.toggle) ? false : true,
                                startDate: this.selectYear.startDate,
                                endDate: this.selectYear.endDate,
                                defaultDate: true
                            }
                            this.updateState()
                        }} />}
                    </div></>}
                {this.selectYear.hasError && <DKLabel className="text-red" text={this.selectYear.errorMsg} />}
                {obj.type == "date-range" && this.renderCalendarForDateSelect(this.getFieldValue(obj), index, obj)}
                {obj.showMask &&
                    <MaskInput
                        setRef={(ref) => obj['showMask'] = ref}
                        showMask={true}
                        className={`p-v-s p-h-r ${obj.key}`}
                        title={obj.name}
                        direction={obj.direction}
                        value={this.getFieldValue(obj)}
                        errorMessage={this.getErrorMessage(obj)}
                        readOnly={obj.readOnly}
                        required={obj.required}
                        showMaskUnmaskInline={obj.showMaskUnmaskInline}
                        tooltip={{
                            content: obj.tooltipText,
                            className: "warning-tooltip-prop",
                        }}
                        onChange={(value) => {
                            obj.canValidate = true
                            this.onChange(value, index, obj);
                        }}
                        canValidate={ obj.canValidate}
                        invalid={ obj.canValidate}
                        validator={(value) => {
                            obj.isValid =this.validator(value, index, obj)
                            return obj.isValid 
                            // this.updateState()
                        }}
                    />
                }
            </>
        )
    }
    renderForm() {
        return (
            <div className="parent-width">
                <div className="row row-responsive flex-wrap border-m border-radius-s card-shadow m-v-l  p-v-s ">
                    {this.editIR8SForm.authorizePerson.map((field, index) => {

                        return (field.uiVisible) ? <div className="web-width-50 ">{this.renderField(field, index)}</div> : null
                    })}
                </div>
                {this.getSectionA()}
                {this.getContributionFullRate()}
                {this.getSectionB()}
                {this.getSectionC()}
                {this.getSectionRemark()}
            </div>
        )
    }
    getHeder() {
        return (
            <div className="row justify-content-between">
                <DKLabel className="fw-m fs-l" text="Edit IR8S Form" />
                <div className="d-flex">
                    <DKButton className="bg-gray1 border-m mr-l" title="Cancel" onClick={() => this.props.onClose()} />
                    <DKButton className="bg-app text-white" title="Save" onClick={() => this.save()} />
                </div>
            </div>
        )
    }
    render() {
        return (
            <Popup popupClass={"report-form-popup"} onClose={() => { }}>
                {this.getHeder()}
                {this.renderForm()}
            </Popup>
        )
    }
}